import { format } from '@pes-ui/utils';
export const applyPriceTemplate = (price, template, placeholder = '#PartnerPrice#') => template.replace(placeholder, price.toString());
const getMinimalPrice = (distributors) => {
  const distributorsWithPrices = distributors.filter((distributor) => {
    return distributor.price > 0;
  });
  if (distributorsWithPrices.length) {
    const distributorsSortedByPrice = distributorsWithPrices.sort((a, b) => a.price - b.price);
    return distributorsSortedByPrice[0].price;
  }
};
export const getPrices = (productsDistributorsInfo, { template, locale }) => {
  return Object.keys(productsDistributorsInfo).reduce((result, commercialReference) => {
    const price = getMinimalPrice(productsDistributorsInfo[commercialReference]);
    if (!price) {
      return result;
    }
    result[commercialReference] = applyPriceTemplate(format(price, { locale }), template);
    return result;
  }, {});
};
